import { isEmpty, map } from 'lodash';
import { useHits } from 'react-instantsearch-hooks-web';
import type { HitsProps } from './interfaces';
import type { BaseHit } from '@sda/helpers/algolia.helpers';

export const Hits = <C extends React.ElementType, T>({
  hitComponent: HitComponent,
  component,
  empty,
  ...restProps
}: HitsProps<C, T> & Record<string, any>) => { // TODO - Better typings here, get rid of Record<string, any>
  const result = useHits<BaseHit<T>>();

  if (Boolean(empty) && isEmpty(result.hits)) {
    return (
      <>
        {empty}
      </>
    );
  }

  const Component: React.ElementType = component;

  return (
    <Component
      {...restProps}
    >
      {map(result.hits, (hit, index) => (
        <HitComponent
          index={index}
          hit={hit as BaseHit<T>}
          key={hit.objectID}
        />
      ))}
    </Component>
  );
};
